export default {
  email (value) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(value)
  },
  fullName (value) {
    return value.split(' ').length === 2
  },
  isEmpty (value) {
    return !value.replace(/\s+/, '').length
  },
  number (value) {
    return !isNaN(value)
  },
  noticePeriod (value) {
    return value < (366 * 5)
  },
  salary (value) {
    return !(value > 10000000 || value < 0)
  },
  validateNoticePeriod (noticePeriod) {
    let error = null
    if (!this.number(noticePeriod)) {
      error = 'Notice period needs to be a number'
    } else if (!this.noticePeriod(noticePeriod)) {
      error = 'Notice period too long'
    } else if (!noticePeriod) {
      error = 'Please Enter Notice Period'
    } else if (parseInt(noticePeriod) === 0) {
      error = 'Notice period cannot be zero'
    }
    return error
  },
  validateSalary (salary) {
    let error = null
    if (!this.number(salary)) {
      error = 'Salary needs to be a number'
    } else if (!this.salary(salary)) {
      error = 'Salary not possible'
    }
    return error
  }
}



// WEBPACK FOOTER //
// ./src/helpers/validators.js